import { Typography } from 'antd'
import { useFFEStore } from '../../store/ffeStore'
import { CompletedOrderCard } from './CompletedOrderCard/CompletedOrderCard'
export const CompletedPurchaseOrderList = () => {
  const purchaseOrders = useFFEStore((state) => state.purchaseOrders)
  if (purchaseOrders.length === 0) {
    return (
      <>
        <Typography.Text type="secondary">
          No purchase orders have been created for this schedule yet. See your
          Items to be Ordered above.
        </Typography.Text>
      </>
    )
  }
  return (
    <>
      {purchaseOrders.map((order) => (
        <CompletedOrderCard key={order.id} order={order} />
      ))}
    </>
  )
}
